import React, { useState } from 'react';
import styled from 'styled-components';
import { FaBasketballBall, FaFootballBall, FaTableTennis } from 'react-icons/fa'; // Example category icons

const CategoryFilterContainer = styled.div`
  display: flex;
  gap: 15px;
  padding: 1rem;
  margin-top: 1rem;
  overflow-x: auto; /* Horizontal scrolling enabled */
  scroll-snap-type: x mandatory;  /* Smooth scrolling effect */
  scroll-behavior: smooth; /* Smooth scroll transition */
  flex-wrap: nowrap;  /* Prevent wrapping to the next line */
  max-width: 100%;
  /* Desktop Styles */
  @media (min-width: 768px) {
    width: 100%;
    justify-content:center;
    align-item:center;
  }
`;

const CategoryCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 125px;
  height: 125px;
  min-width: 140px;
  min-height: 150px;
  border-radius: 25px;
  background-color: #f8f8f8;
  border: 2px solid #ddd;
  position: relative;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
  box-shadow: ${(props) => (props.isSelected ? '0px 4px 12px rgba(0, 0, 0, 0.2)' : '0px 4px 8px rgba(0, 0, 0, 0.1)')};

  /* Ensure that the width and height are fixed regardless of the container resizing */
  flex-shrink: 0;  /* Prevent shrinking */
  flex-grow: 0;    /* Prevent growing */
  
  &:hover {
    transform: scale(1.05);
  }

  scroll-snap-align: start; /* Snap to each card when scrolling */
`;

const CategoryIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: #66bb6a;
`;

const CategoryLabel = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  color: #263238;
  font-weight: bold;
  font-size: 0.9rem;
  // text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);
`;

const CategoryFilter = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const categories = [
    { id: 1, name: 'Badminton', icon: <img src='/images/badminton.png' width='50px' height='50px' />,  },
    { id: 2, name: 'Cricket', icon: <img src='/images/cricket.png' width='50px' height='50px' />, },
    { id: 3, name: 'Football', icon: <img src='/images/football.png' width='50px' height='50px' />,  },
    { id: 4, name: 'Volleyball', icon: <img src='/images/volleyball.png' width='50px' height='50px' />,  },
    // { id: 5, name: 'Baseball', icon: <FaBasketballBall />, },
    // { id: 6, name: 'Soccer', icon: <img src='/images/badminton.png' width='50px' height='50px' />, },
    // { id: 7, name: 'Badminton', icon: <FaTableTennis />,  },
    // Add more categories as needed
  ];

  const handleCategoryClick = (id) => {
    setSelectedCategory(id === selectedCategory ? null : id); // Toggle selection
  };

  return (
    <CategoryFilterContainer>
      {categories.map((category) => (
        <CategoryCard
          key={category.id}
          isSelected={category.id === selectedCategory}
          onClick={() => handleCategoryClick(category.id)}
          style={{
            backgroundColor: category.id === selectedCategory ? '#66bb6a' : '#f8f8f8',
          }}
        >
          <CategoryIconWrapper style={{ backgroundColor: category.id === selectedCategory ? '#ffffff' : '#f8f8f8' }}>
            {category.icon}
          </CategoryIconWrapper>
          <CategoryLabel>{category.name}</CategoryLabel>
        </CategoryCard>
      ))}
    </CategoryFilterContainer>
  );
};

export default CategoryFilter;
